import React from "react";

export default function LoadablePlaceholder({ error, pastDelay }) {
  if (error) {
    return (
      <div className="color--is-error">
        Error!
      </div>
    );
  } else if (pastDelay) {
    return (
      <div>
        Loading...
      </div>
    );
  } else {
    return null;
  }
}
